






























import { Component, Vue } from 'vue-property-decorator'
import AdditionalData from './AdditionalData.vue'
import { DefaultServerResponse } from '@/components/ui/TechTaskCard.vue'
import { FacebookPostRow } from './facebook-post-row'
import request from '@/helpers/requests'


interface ResponseData extends DefaultServerResponse {
    data: {
        hasMore: boolean;
        data: FacebookPostRow[];
    };
}


@Component({
    components: {
        AdditionalData
    }
})
export default class CommTable extends Vue {
    beginDate = '2020-04-01'
    endDate = '2020-06-01'
    loading = false
    expanded = []
    report: FacebookPostRow[] = []
    headers = [
        { text: 'Pulsem Account ID', value: 'pulsemAccountId', align: 'left' },
        { text: 'Location Name', value: 'locationName', align: 'left' },
        { text: 'Published Posts', value: 'publishedPosts' },
        { text: 'Latest Post', value: 'latestPost' }
    ]

    async getData(): Promise<ResponseData> {
        return await request.post('/support/global-reporting/facebook-posts', {
            beginDate: this.beginDate,
            endDate: this.endDate
        }) as ResponseData
    }

    async fetchReports() {
        this.loading = true
        const data = await this.getData()
        this.report = data.data.data
        this.loading = false
    }
}
